import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/Home.vue"),
  },
  
  {
    path: "/sustainable",
    name: "sustainable",
    component: () => import("@/views/Sustainable.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/About.vue"),
  },
  {
    path: "/showcase",
    name: "showcase",
    component: () => import("@/views/Showcase.vue"),
  },
  {
    path: "/service",
    name: "service",
    component: () => import("@/views/Service.vue"),
  },
  {
    path: "/order",
    name: "order",
    component: () => import("@/views/Order.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("@/views/Contact.vue"),
  },
  {
    path: "/test",
    name: "test",
    component: () => import("@/views/test.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
